import SecondaryLayout from '@app/layouts/SecondaryLayout';
import {
  SuccessFeeHeader,
  SuccessFeePrepayments,
  SuccessFeeSidebar,
  SuccessFeeSummary,
  SuccessFeeTotal,
} from '@components/SuccessFee/index';
import { useStoreState } from 'easy-peasy';
import { useParams } from 'react-router-dom';
import { selectorRootState } from '@model/index';
import { ShareLinkModal } from '@components/ShareLinkModal/index';
import Modal from '@components/Modal';
import { MODAL_IDS_MAP } from '@app/constants/modals';
import { useTranslation } from 'react-i18next';
import { candidatesSelector } from '@model/Candidate/Candidate.selectors';
import { useMemo } from 'react';

export const SuccessFee = () => {
  const { t } = useTranslation();
  const { results: candidates } = useStoreState(candidatesSelector);
  const { isModalOpened, modalId } = useStoreState(selectorRootState);
  const { candidateId } = useParams();

  const currentClosing = useMemo(() => {
    if (!candidates || !candidateId) return null;

    return candidates.find(candidate => candidate.id === candidateId);
  }, [candidates, candidateId]);

  const isShareLinkModalVisible =
    isModalOpened && modalId === MODAL_IDS_MAP.SHARE;

  return (
    <SecondaryLayout>
      <SuccessFeeHeader />

      {!!currentClosing && (
        <div className="rev-o-container">
          <div className="rev-o-grid rev-u-mt-32">
            <SuccessFeeSidebar
              candidateName={t('common.formatting.fullName', {
                firstName: currentClosing.firstName,
                lastName: currentClosing.lastName,
              })}
            />

            <div className="rev-u-px-16 rev-o-col-12 rev-o-col--medium-8">
              <SuccessFeeSummary
                prospect={currentClosing.offer.successFeeRecap}
              />

              <SuccessFeePrepayments
                prospect={currentClosing.offer.successFeeRecap}
              />

              <SuccessFeeTotal
                prospect={currentClosing.offer.successFeeRecap}
              />
            </div>
          </div>
        </div>
      )}

      <Modal visible={isShareLinkModalVisible}>
        <ShareLinkModal />
      </Modal>
    </SecondaryLayout>
  );
};
